import { PageDetailContent } from '@client/toolkit';

import { AgreementNameField } from '../components/agreement-name/agreement-name-field.component';
import { AgreementAuditTrailCard } from '../components/agreement-audit-trail/agreement-audit-trail-card.component';
import { PageContentAnimation } from '../../../../components';

export function AgreementAuditTrailRoute() {
  return (
    <PageDetailContent>
      <PageContentAnimation className="space-y-4 px-4 pt-2 pb-8 rounded-lg shadow-lg border border-border">
        <AgreementNameField />
        <AgreementAuditTrailCard />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
